export function downloadQrCodeCard({
  card,
  logoImg,
  qrCanvas,
  textColor,
}: {
  card: HTMLElement | null;
  logoImg: HTMLImageElement | null;
  qrCanvas: HTMLCanvasElement | null | undefined;
  textColor: string;
}) {
  if (!card || !logoImg || !qrCanvas) return;

  const scale = 2;
  const cardRect = card.getBoundingClientRect();
  const logoRect = logoImg.getBoundingClientRect();
  const qrRect = qrCanvas.getBoundingClientRect();

  const canvas = document.createElement("canvas");
  canvas.width = cardRect.width * scale;
  canvas.height = cardRect.height * scale;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  ctx.scale(scale, scale);
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, cardRect.width, cardRect.height);

  ctx.drawImage(
    logoImg,
    logoRect.left - cardRect.left,
    logoRect.top - cardRect.top,
    logoRect.width,
    logoRect.height,
  );

  ctx.fillStyle = textColor;
  ctx.font = "16px sans-serif";
  ctx.textAlign = "center";
  ctx.fillText(
    "QRCode Toppus",
    cardRect.width / 2,
    logoRect.bottom - cardRect.top + 32,
  );

  ctx.drawImage(
    qrCanvas,
    qrRect.left - cardRect.left,
    qrRect.top - cardRect.top,
    qrRect.width,
    qrRect.height,
  );

  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/jpeg");
  a.download = "qrcode-toppus.jpeg";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
